import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import servicePages from "../data/servicePages";
import logo from "../asset/home/CPA.png";

export default function Footer() {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  const handleSubscribe = () => {
    if (email.trim()) {
      navigate('/contact', { state: { email: email.trim() } });
      setEmail("");
    } else {
      navigate('/contact');
    }
  };

  return (
    <footer className="bg-white">
      {/* --- Newsletter Section (Upper Edge) --- */}
      <div className="bg-slate-50 border-b border-slate-200 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-between items-end gap-8 footer-newsletter-flex">
            <div className="flex-1 min-w-[240px] footer-newsletter-text">
              <h2 className="text-2xl font-bold text-slate-900 mb-3 tracking-tight">
                Sign up for our newsletter
              </h2>
              <p className="text-slate-600 text-sm leading-relaxed max-w-md">
                Monthly hand-picked discoveries and stories of thriving in a new
                world of design. GIFs (often) included.
              </p>
            </div>
            <div className="flex flex-wrap items-end gap-4 footer-form-flex">
              <div className="min-w-[260px] footer-input-wrap">
                <span className="block text-xs font-semibold tracking-wide text-slate-500 mb-1.5">
                  EMAIL ADDRESS
                </span>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="yourname@example.com"
                  className="w-full bg-white border border-slate-300 rounded-lg px-4 py-3 text-slate-900 text-sm focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition-all"
                />
              </div>
              <button onClick={handleSubscribe} className="bg-[#203468] text-white font-semibold text-sm px-6 py-3 rounded-lg hover:bg-[#019BD7] transition-colors whitespace-nowrap footer-btn">
                Subscribe
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* --- Main Footer Content --- */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
  <div className="grid grid-cols-1 md:grid-cols-12 gap-12 lg:gap-8">
    {/* Brand Column */}
    <div className="md:col-span-12 lg:col-span-5 pr-0 lg:pr-12 footer-brand-col">
      <Link to="/" className="flex items-center gap-3 mb-6">
        <img
          src={logo}
          alt="The Alpha CPAs logo"
          className="h-10 w-auto object-contain"
        />
        <span className="font-serif text-2xl font-bold tracking-tight text-slate-900">
          Alpha <span className="text-orange-500">Accountants</span>
        </span>
      </Link>

      <p className="text-slate-600 text-sm leading-relaxed mb-8 max-w-sm">
        Precision in practice, clarity in complexity. Premier financial
        advisory for the global enterprise.
      </p>

      {/* Social Icons */}
      <div className="flex items-center gap-5 footer-socials">
        <a
          href="https://www.linkedin.com/company/the-alphaaccountants/posts/?feedView=all"
          className="text-slate-500 hover:text-slate-900 transition-colors"
          aria-label="LinkedIn"
        >
          <svg
            className="w-5 h-5"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
          </svg>
        </a>
        <a
          href="https://x.com/"
          className="text-slate-500 hover:text-slate-900 transition-colors"
          aria-label="X (Twitter)"
        >
          <svg
            className="w-5 h-5"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
          </svg>
        </a>
        <a
          href="https://www.instagram.com/"
          className="text-slate-500 hover:text-slate-900 transition-colors"
          aria-label="Instagram"
        >
          <svg
            className="w-5 h-5"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.919-.058-1.265-.069-1.644-.069-4.849 0-3.204.013-3.583.069-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
          </svg>
        </a>
        <a
          href="https://www.youtube.com/"
          className="text-slate-500 hover:text-slate-900 transition-colors"
          aria-label="YouTube"
        >
          <svg
            className="w-5 h-5"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M19.615 3.184c-3.604-.246-11.626-.246-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 4-8 4z" />
          </svg>
        </a>
      </div>
    </div>

    {/* Links Columns */}
    <div className="md:col-span-6 lg:col-span-3 footer-links-col">
      <h3 className="text-slate-900 font-bold text-base mb-6">Company</h3>
      <ul className="flex flex-col gap-4 footer-links-ul">
        <li>
          <Link
            to="/about"
            className="text-slate-600 text-sm hover:text-slate-900 transition-colors"
          >
            About Us
          </Link>
        </li>
        <li>
          <Link
            to="/team"
            className="text-slate-600 text-sm hover:text-slate-900 transition-colors"
          >
            Leadership
          </Link>
        </li>
        <li>
          <Link
            to="/services"
            className="text-slate-600 text-sm hover:text-slate-900 transition-colors"
          >
            Services
          </Link>
        </li>
        {servicePages.slice(0, 6).map((p) => (
          <li key={p.slug}>
            <Link
              to={`/services/${p.slug}`}
              className="text-slate-600 text-sm hover:text-slate-900 transition-colors"
            >
              {p.name}
            </Link>
          </li>
        ))}
        <li>
          <Link
            to="/contact"
            className="text-slate-600 text-sm hover:text-slate-900 transition-colors"
          >
            Contact
          </Link>
        </li>
      </ul>
    </div>

    <div className="md:col-span-6 lg:col-span-4 footer-links-col">
      <h3 className="text-slate-900 font-bold text-base mb-6">
        Expertise
      </h3>
      <ul className="flex flex-col gap-4 footer-links-ul">
        <li>
          <Link
            to="/expertise#financial-reporting"
            className="text-slate-600 text-sm hover:text-slate-900 transition-colors"
          >
            Comprehensive Financial Reporting
          </Link>
        </li>
        <li>
          <Link
            to="/expertise#operational-insights"
            className="text-slate-600 text-sm hover:text-slate-900 transition-colors"
          >
            Operational Financial Insights
          </Link>
        </li>
        <li>
          <Link
            to="/expertise#management-reporting"
            className="text-slate-600 text-sm hover:text-slate-900 transition-colors"
          >
            Management Reporting & Analysis
          </Link>
        </li>
        <li>
          <Link
            to="/expertise#profit-loss"
            className="text-slate-600 text-sm hover:text-slate-900 transition-colors"
          >
            Profit & Loss segmentation
          </Link>
        </li>
      </ul>
    </div>
  </div>
</div>

      {/* --- Lower Copyright Bar with Top & Bottom Padding --- */}
      <div className="border-t border-slate-200 bg-slate-50 py-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-slate-500 text-xs tracking-wide text-center">
            © 2019 - ALPHA ACCOUNTANTS IS A REGISTERED TRADEMARK OF FUNCTIONAL SOFTWARE,
            INC.
          </p>
        </div>
      </div>
    </footer>
  );
}
